import mockAxios, { AxiosResponse } from 'axios';
import { IWorkflowFormTemplateServiceMock } from './workflow-form-template.mock.types';

export const mockWorkflowFormTemplateService = (): IWorkflowFormTemplateServiceMock => ({
  fetchWorkflowFormTemplates: jest.fn(),
  fetchWorkflowFormTemplate: jest.fn(),
  createWorkflowFormTemplate: jest.fn(),
  updateWorkflowFormTemplate: jest.fn(),
  deleteWorkflowFormTemplate: jest.fn(),

  fetchWorkflowFormTemplatesRevisions: jest.fn(),
  fetchWorkflowFormTemplateRevisions: jest.fn(),
  fetchWorkflowFormTemplateRevision: jest.fn(),
  createWorkflowFormTemplateRevision: jest.fn(),
  updateWorkflowFormTemplateRevision: jest.fn(),
  deleteWorkflowFormTemplateRevision: jest.fn(),

  addWorkflowFormTemplateAttachment: jest.fn(),
  removeWorkflowFormTemplateAttachment: jest.fn(),
  downloadWorkflowFormTemplateAttachment: jest.fn(),
  fetchWorkflowFormTemplateRevisionsStakeholderUsers: jest.fn(),

  createNewWorkflowTemplateRevision: jest.fn(),

  updateWorkflowFormTemplateRevisionState: jest.fn(),

  fetchTemplateWorkflowStates: jest.fn(),

  fetchWorkflowTemplateUsers: jest.fn(),

  //fields
  fetchWorkflowFormFields: jest.fn(),
  fetchWorkflowFormField: jest.fn(),
  createWorkflowFormField: jest.fn(),
  updateWorkflowFormField: jest.fn(),
  deleteWorkflowFormField: jest.fn(),
  uploadWorkflowFormFieldOptions: jest.fn(),

  //todos
  fetchWorkflowFormFieldOptionTodos: jest.fn(),
  fetchWorkflowFormFieldOptionTodo: jest.fn(),
  createWorkflowFormFieldOptionTodo: jest.fn(),
  updateWorkflowFormFieldOptionTodo: jest.fn(),
  deleteWorkflowFormFieldOptionTodo: jest.fn(),

  //todo-templates
  fetchWorkflowFormTodoTemplates: jest.fn(),
  fetchWorkflowFormTodoTemplate: jest.fn(),
  createWorkflowFormTodoTemplate: jest.fn(),
  updateWorkflowFormTodoTemplate: jest.fn(),
  deleteWorkflowFormTodoTemplate: jest.fn()
});

export const mockWorkflowFormTemplateAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
